import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment";
//import { Editor } from "@tinymce/tinymce-react";
import { connect } from "react-redux";

//componentes
import "./mostrarTrabajos.css";
import Alert from "../../modal/alert";
import EvaluarTareas from "../evaluarTareas/index";
import CalificarTareas from "../calificarTareas/calificarTareas";

class MostrarTrabajos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iconcepto: [],
      listaOn: false,
      verplanillaOn: false,
      mensajealerta: false,
      consultar2On: false,
      cedulaAlumno: "",
      nombreAlumno: "",
      fecha: "",
      textoevo: "",
      anoEscolar: moment().format("YYYY"),
      idprofesor: "",
      idcurso: "",
      idmateria: "",
      idfechaPlani: "",
      fechaDesde: "",
      fechaHasta: "",
      tipoPlanificacion: "",
      idplanificacion: "",
      idplani: "",
      descripcion: "",
      ocultar: "",
      idactividad: "",
      idtareas: "",
      idarchivos: "",
      nombreEvaluacion: "",
      trimestre: "",
      banderag: false,
      botonguardarOn: false,
      botonmodiOn: false,
      elimi: false,
      activarNotaOn: false,
      activarEvaluacionOn: false,
      iactividades: [],
      imaterias: [],
      icursos: [],
      iprofesor: [],
      ifechaPlani: [],
      ifechaplani: [],
      ianoEscolar: [moment().format("YYYY")],
      itrabajoAlumnos: [],
      tipocierre: "NO",
    };
  }

  limpiar = () => {
    this.setState({
      listaOn: false,
      verplanillaOn: false,
      consultar2On: false,
      cedulaAlumno: "",
      nombreAlumno: "",
      fecha: "",
      textoevo: "",
      anoEscolar: moment().format("YYYY"),
      idprofesor: "",
      idcurso: "",
      idmateria: "",
      idfechaPlani: "",
      fechaDesde: "",
      tipoPlanificacion: "",
      idplanificacion: "",
      idplani: "",
      descripcion: "",
      ocultar: "",
      idactividad: "",
      idarchivos: "",
      trimestre:'',
      nombreEvaluacion: "",
      imaterias: [],
      botonguardarOn: false,
      botonmodiOn: false,
      mensajealerta: false,
      elimi: false,
      activarNotaOn: false,
      activarEvaluacionOn: false,
      tipocierre: "NO",
    });
  };

  onChange(e) {
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  onChange1(e) {
    // console.log(this.state.nana)
    // console.log(e.target.checked)
    if (e.target.checked) {
      this.setState({
        tipocierre: "SI",
      });
    } else {
      this.setState({
        tipocierre: "NO",
      });
    }
  }

  onChange2(e) {
    let index = e.target.getAttribute("id");
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });
    if (index === "anoEscolar") this.buscarProfesor();
    if (index === "idprofesor") this.buscarCurso(e.target.value);
    if (index === "idcurso") this.buscarPlanE(e.target.value);
    if (index === "idmateria") this.consultarActividades(e.target.value);
  }

  onChange3 = (e) => {
    let idplane = e.target.value;
    let itemfind = this.state.iactividades.find((e) => e.variable1 === idplane);
    let index =
      typeof itemfind !== "undefined"
        ? this.state.iactividades.indexOf(itemfind)
        : 0;
    //console.log(index)
    let nombreA = this.state.iactividades[index].variable5;
    //console.log("nombre Actividad: "+nombreA)
    //console.log("idmateria: "+xidmateria)
    this.setState({
      [e.target.name]: e.target.value,
      nombreEvaluacion: nombreA,
    });
  };

  consultar() {
    if (this.state.idtareas > 0) {
      let data = new FormData();
      data.append("idactividad", this.state.idtareas);
      data.append("tipocierre", this.state.tipocierre);
      
      
      if (this.props.usuario1.nivel === "3") {
        data.append("boton", "consultarAdjuntosAlumnos2");
      } else {
        data.append("boton", "consultarAdjuntosAlumnos4");
      }

      axios({
        method: "post",
        url: "https://institutobilinguelasnaciones.com/prueba/backend/subirTareas.php",
        data: data,
      }).then((res) => {
        let xitrabajoAlumnos = res.data.variable2;
        this.setState({
          itrabajoAlumnos: xitrabajoAlumnos,
          consultar2On: false,
        });
      });
    }
  }

  consultar2() {
    if (this.state.idtareas > 0) {
      let data = new FormData();
      data.append("idactividad", this.state.idtareas);
      data.append("boton", "consultarAdjuntosAlumnos4");
      axios({
        method: "post",
        url: "https://institutobilinguelasnaciones.com/prueba/backend/subirTareas.php",
        data: data,
      }).then((res) => {
        let xitrabajoAlumnos = res.data.variable2;
        this.setState({
          itrabajoAlumnos: xitrabajoAlumnos,
          consultar2On: true,
        });
      });
    }
  }

  consultarActividades(e) {
    let data = new FormData();
    data.append("idprofesor", this.state.idprofesor);
    data.append("idgrado", this.state.idcurso);
    if (this.props.usuario1.nivel !== "3") data.append("tipocierre", 'SI'); 
    if (this.props.usuario1.nivel === "3") data.append("tipocierre", 'NO'); 
    data.append("trimestre", this.state.trimestre);
    
    if (e.length > 0) data.append("idmateria", e);
    if (e.length === 0) data.append("idmateria", this.state.idmateria);
    data.append("anoEscolar", this.state.anoEscolar);
    data.append("boton", "buscarActividades");

    axios({
      method: "post",
      url: "https://institutobilinguelasnaciones.com/prueba/backend/actividades.php",
      data: data,
    }).then((res) => {
      let xiactividades = res.data.variable2;
      this.setState({
        iactividades: xiactividades,
      });
    });
  }

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  cerrarLista = () => {
    //console.log(this.state.listaOn)
    if (this.state.listaOn) {
      this.setState({
        listaOn: false,
      });
    }
    if (!this.state.listaOn) {
      this.setState({
        listaOn: true,
      });
    }
  };

  buscarFPI = (e) => {
    let form = new FormData();
    form.append("idfechaPlanificacion", e);
    form.append("boton", "buscarFPI");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/prueba/backend/planificacion.php";
    axios.post(xurl, form, config).then((res) => {
      if (res.data.variable1) {
        this.setState({
          tipoPlanificacion: res.data.variable2,
        });
      } else {
        this.setState({
          mensajealerta: true,
          tituloM: "Menu Crear Planificacion",
          cuerpoM:
            "Debe comunicarse con la coordinacion e indicarle que el tipo de planificacion que usted intenta generar no tiene asignada el tipo de Planificacion (SEMANAL o MENSUAL).",
        });
      }
    });
  };

  buscarFP = (e) => {
    let form = new FormData();
    form.append("idgrado", e);
    form.append("boton", "buscarFP");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/prueba/backend/planificacion.php";
    axios.post(xurl, form, config).then((res) => {
      let xifechaPlani = res.data.variable2;
      this.setState({
        ifechaPlani: xifechaPlani,
        idfechaPlani: "",
      });
    });
  };

  buscarAnioEscolar = () => {
    let data = new FormData();
    data.append("boton", "buscarAnioEscolar");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/prueba/backend/maternal.php";
    axios.post(xurl, data, config).then((res) => {
      if (res.data.variable1) {
        this.setState({
          //anoEscolar: res.data.variable2,
          ianoEscolar: res.data.variable3,
        });
      }
    });
  };

  buscarProfesor = () => {
    console.log(this.props.usuario1.nivel);
    let form = new FormData();
    form.append("clave", this.props.usuario1.password);
    if (this.props.usuario1.nivel === "3") {
      form.append("boton", "buscarPersonal3");
    } else {
      form.append("boton", "buscarPersonal2");
    }
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl = "https://institutobilinguelasnaciones.com/prueba/backend/nomina2.php";
    axios.post(xurl, form, config).then((res) => {
      if (this.props.usuario1.nivel === "3") {
        let iprofesor = res.data.variable1;
        iprofesor.map((item, i) => {
          this.setState({ idprofesor: item.variable1 });
          this.buscarCurso(item.variable1);
        });
      } else {
        let xiprofesor = res.data.variable1;
        this.setState({ iprofesor: xiprofesor });
      }
    });
  };

  buscarCurso = (e) => {
    if (this.state.anoEscolar.length > 0) {
      if (e.length > 0) {
        let data = new FormData();
        data.append("idprofesor", e);
        data.append("boton", "buscarCurso");

        let config = {
          headers: {
            "Content-Type": "text/html",
          },
        };
        const xurl =
          "https://institutobilinguelasnaciones.com/prueba/backend/planificacion.php";
        axios
          .post(xurl, data, config)

          .then((res) => {
            let xicursos = res.data.variable2;
            if (res.data.variable1) {
              this.setState({
                icursos: xicursos,
              });
            } else {
              this.setState({
                icursos: [],
              });
              if (res.data.variable3.length > 0) {
                this.setState({
                  mensajealerta: true,
                  tituloM: "Menu Asignar Notas.",
                  cuerpoM: res.data.variable3,
                });
              }
            }
          });
      } else {
        this.setState({
          mensajealerta: true,
          tituloM: "Menu Asignar Notas.",
          cuerpoM: "Debe Seleccionar un Profesor, gracias.",
        });
      }
    } else {
      this.setState({
        idprofesor: "",
        mensajealerta: true,
        tituloM: "Menu Asignar Notas.",
        cuerpoM: "Debe Seleccionar un Año Escolar, gracias.",
      });
    }
  };

  buscarPlanE = (e) => {
    if (this.state.idprofesor.length > 0) {
      let data = new FormData();
      data.append("anoEscolar", this.state.anoEscolar);
      data.append("idgrado", e);
      data.append("idprofesor", this.state.idprofesor);
      data.append("boton", "buscarPlanE");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/prueba/backend/planificacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          let ximaterias = res.data.variable2;
          if (res.data.variable1) {
            this.setState({
              imaterias: ximaterias,
              idmateria: "",
            });
          } else {
            this.setState({
              imaterias: [],
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Asignar Notas.",
        cuerpoM: "Debe Seleccionar un Profesor, gracias.",
      });
    }
  };

  eliminar1 = (e) => {
    this.setState({
      mensajealerta: true,
      tituloM: "Menu Crear Actividad.",
      cuerpoM: "Realmente Quiere Eliminar la Actividad...",
      idactividad: e,
      elimi: true,
    });
  };

  handleEliminar = () => {
    this.setState({
      mensajealerta: false,
      elimi: false,
    });
    this.eliminar();
    //console.log('eliminar')
  };

  EvaluarTrabajo = (e, f, x,z) => {
    if (this.state.activarEvaluacionOn) {
      this.setState({
        activarEvaluacionOn: false,
        idarchivos: "",
        cedulaAlumno: "",
        nombreAlumno: "",
        trimestre: "",
      });
    } else {
      this.setState({
        activarEvaluacionOn: true,
        idarchivos: e,
        nombreAlumno: f,
        cedulaAlumno: x,
        trimestre: z,
      });
    }
  };

  notasTrabajo = (e) => {
    if (this.state.activarNotaOn) {
      this.setState({ activarNotaOn: false, idarchivos: "" });
    } else {
      this.setState({ activarNotaOn: true, idarchivos: e });
      //console.log(e);
    }
  };

  handleEditorChange(textoevo, editor) {
    this.setState({ textoevo });
  }
  componentDidMount() {
    this.buscarProfesor();
    //this.buscarAnioEscolar();
  }

  render() {
    return (
      <div className="principal-pago row">
        <div className="contenedor-cxc col-12">
          <div className="titulo-cxc ">
            <p>ASIGNACIONES RECIBIDAS DE ALUMNOS. </p>
          </div>
          {this.state.mensajealerta === true && (
            <Alert
              tituloMensaje={this.state.tituloM}
              cuerpoMensaje={this.state.cuerpoM}
              open={this.state.mensajealerta}
              handleClose={this.handleClose}
              eliminar={this.state.elimi}
              handleEliminar={this.handleEliminar}
            />
          )}

          {this.state.activarNotaOn === true && (
            <div className="flotadorT">
              <div className="flotador1f">
                <EvaluarTareas
                  idarchivos={this.state.idarchivos}
                  handleClose={this.notasTrabajo}
                />
              </div>
            </div>
          )}

          {this.state.activarEvaluacionOn === true && (
            <div className="flotadorTE">
              <div className="flotador1f">
                <CalificarTareas
                  idprofesor={this.state.idprofesor}
                  idmateria={this.state.idmateria}
                  idcurso={this.state.idcurso}
                  idtareas={this.state.idtareas}
                  trimestre={this.state.trimestre}
                  anoEscolar={this.state.anoEscolar}
                  cedulaAlumno={this.state.cedulaAlumno}
                  nombreAlumno={this.state.nombreAlumno}
                  idarchivos={this.state.idarchivos}
                  nombreEvaluacion={this.state.nombreEvaluacion}
                  handleClose={this.EvaluarTrabajo}
                />
              </div>
            </div>
          )}

          <div className="historia-contenidoant">
            <div className="form-groupev col-12">
              <div className="row">
                <div className="cont-personal col-12">
                  {this.props.usuario1.nivel === "2" && (
                    <div className="contenedorcedula1f col-4">
                      <select
                        id="idprofesor"
                        name="idprofesor"
                        value={this.state.idprofesor}
                        onChange={this.onChange2.bind(this)}
                      >
                        <option value="">--- Seleccione un Profesor ---</option>
                        {this.state.iprofesor.map((item, i) => {
                          return (
                            <option key={i} value={item.variable1}>
                              {item.variable2}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  )}
                  <div className="contenedorcedula1f col-2">
                    <select
                      id="trimestre"
                      name="trimestre"
                      value={this.state.trimestre}
                      onChange={this.onChange2.bind(this)}
                    >
                      <option>-- Seleccionar Trimestre --</option>
                      <option value="1">1ER. TRIMESTRE</option>
                      <option value="2">2DO. TRIMESTRE</option>
                      <option value="3">3ER. TRIMESTRE</option>
                    </select>
                  </div>
                  <div className="contenedorcedula1f col-2">
                    <select
                      id="idcurso"
                      name="idcurso"
                      value={this.state.idcurso}
                      onChange={this.onChange2.bind(this)}
                    >
                      <option>-- Seleccionar Grado --</option>
                      {this.state.icursos.map((item, i) => {
                        return (
                          <option key={i} value={item.variable1}>
                            {item.variable2}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="contenedorcedula1f col-2">
                    <select
                      id="idmateria"
                      name="idmateria"
                      value={this.state.idmateria}
                      onChange={this.onChange2.bind(this)}
                    >
                      <option>-- Materia --</option>
                      {this.state.imaterias.map((item, i) => {
                        return (
                          <option key={i} value={item.variable1}>
                            {item.variable2}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="contenedorcedula1f col-2">
                    <select
                      id="idtareas"
                      name="idtareas"
                      value={this.state.idtareas}
                      onChange={this.onChange3.bind(this)}
                    >
                      <option>-- Tareas --</option>
                      {this.state.iactividades.map((item, i) => {
                        return (
                          <option key={i} value={item.variable1}>
                            {item.variable5}
                            {/* {item.variable5} - {item.variable1} */}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="botones col-12">
                  <div className="acciones">
                    {this.props.usuario1.nivel === "3" && (
                      <button
                        className={
                          !this.state.botonguardarOn ? "boton" : "botonOf"
                        }
                        onClick={
                          !this.state.botonguardarOn
                            ? this.consultar2.bind(this)
                            : ""
                        }
                      >
                        Datos Pendientes
                      </button>
                    )}

                    {/* {this.props.usuario1.nivel !== "3" && (
                      <div className="contenedorcedula1f col-2">
                        <p className="">Sin Cierre:</p>

                        <input
                          type="checkbox"
                          id="oferta1"
                          name="tipocierre"
                          value="SI"
                          checked={this.state.tipocierre === "SI"}
                          onChange={this.onChange1.bind(this)}
                        />
                      </div>
                    )} */}

                    {/* <td className="totalescxcx" width="10">
                      <input
                        type="checkbox"
                        className="opvacunacionsi"
                        name={item.variable1}
                        id={item.variable1}
                        checked={item.variable3 === "1"}
                        onChange={this.onChange4.bind(this)}
                      />
                    </td> */}

                    <button
                      className={
                        !this.state.botonguardarOn ? "boton" : "botonOf"
                      }
                      onClick={
                        !this.state.botonguardarOn
                          ? this.consultar.bind(this)
                          : ""
                      }
                    >
                      Consultar
                    </button>

                    <Link to="/">
                      <button className="boton">Salir</button>
                    </Link>
                    {/* <button className="boton" onClick={this.limpiar.bind(this)}>
                      Limpiar
                    </button> */}
                  </div>
                </div>
              </div>
              <div className="cont-listmedix row">
                <div className="listcxcx col-12">
                  <table className="tablacxcx" border="1">
                    <thead>
                      <tr>
                        <th className="titucxc3">NOMBRE ALUMNO</th>
                        <th className="titucxc3">NOMBRE ARCHIVO</th>
                        <th className="titucxc3">FECHA</th>
                        <th className="titucxc3">VALOR</th>
                        <th className="titucxc3xpe">
                          <span className="titulo-eliminar">
                            <span className="cerrarme5"></span>
                            {/* <span className="cerrarme3"></span> */}
                          </span>
                        </th>
                      </tr>
                    </thead>

                    {this.state.itrabajoAlumnos.map((item, i) => {
                      return (
                        <tr
                          className={i % 2 === 0 ? "odd" : "odd"}
                          key={item.variable1}
                          id="tabla"
                        >
                          <td className="totalescxcx">{item.variable2}</td>
                          <td className="totalescxcx">{item.variable3}</td>
                          <td className="totalescxcx">{item.variable4}</td>
                          {item.variable3 !== "" ? (
                            <td className="totalescxcx">{item.variable10}</td>
                          ) : (
                            <td className="totalescxcx">{}</td>
                          )}
                          <td className="xcerr">
                            <a
                              href={
                                "https://institutobilinguelasnaciones.com/prueba/backend/" +
                                item.variable5
                              }
                              target="__blank"
                            >
                              {" "}
                              {item.variable5 !== "" && (
                                <span className="cerrarme7"></span>
                              )}
                            </a>
                            {this.props.usuario1.nivel === "2"
                              ? item.variable7 === 0 && (
                                  <span
                                    className="cerrarme6"
                                    onClick={this.notasTrabajo.bind(
                                      this,
                                      item.variable1
                                    )}
                                  ></span>
                                )
                              : item.variable5 !== "" && (
                                  <span
                                    className="cerrarme6"
                                    onClick={this.notasTrabajo.bind(
                                      this,
                                      item.variable1
                                    )}
                                  ></span>
                                )}

                            {this.props.usuario1.nivel === "2" ? (
                              item.variable8 === 0 && (
                                <span
                                  className="cerrarme8"
                                  onClick={() => {
                                    this.EvaluarTrabajo(
                                      item.variable1,
                                      item.variable2,
                                      item.variable6
                                    );
                                  }}
                                ></span>
                              )
                            ) : item.variable5 !== "" &&
                              item.variable8 === 0 &&
                              this.state.consultar2On === true ? (
                              <span
                                className="cerrarme8"
                                onClick={() => {
                                  this.EvaluarTrabajo(
                                    item.variable1,
                                    item.variable2,
                                    item.variable6
                                  );
                                }}
                              ></span>
                            ) : item.variable5 !== "" &&
                              this.state.consultar2On === false ? (
                              item.variable10 !== "0" && (
                                <span
                                  className="cerrarme8"
                                  onClick={() => {
                                    this.EvaluarTrabajo(
                                      item.variable1,
                                      item.variable2,
                                      item.variable6,
                                      item.variable11
                                    );
                                  }}
                                ></span>
                              )
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};
export default connect(mapStateToProps)(MostrarTrabajos);
